module.exports = __webpack_public_path__ + "static/media/kuehnenagel.637d1cbf.png";